import { useState } from "react";
import './Faq.scss';

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqData = [
    {
      question: "What is FNOTrader?",
      answer:
        "FNOTrader is a comprehensive platform designed for Futures and Options traders, providing advanced analysis tools and real-time market insights to help traders make informed decisions.",
    },
    {
      question: "How do I get started?",
      answer:
        "Simply sign up for a free trial, connect your broker account, and start using our powerful analysis tools. Our platform guides you through the entire process.",
    },
    {
      question: "Which brokers do you support?",
      answer:
        "We support major Indian brokers including Aliceblue, ICICI Direct, 5paisa, and Angel Broking. We're constantly adding more brokers to our platform.",
    },
    {
      question: "Is my data secure?",
      answer:
        "Yes, we take security seriously. All data is encrypted and we follow industry-standard security practices to protect your information and trading activities.",
    },
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq">
      <div className="container">
        <div className="header">
          <h2>Frequently asked questions</h2>
          <p>Got questions? We've got answers</p>
        </div>

        <div className="faq-list">
          {faqData.map((faq, index) => (
            <div key={index} className="faq-item">
              <button
                className="faq-button"
                onClick={() => toggleFaq(index)}
              >
                <div className="button-content">
                  <span className="question">{faq.question}</span>
                  <svg
                    className={`icon ${openIndex === index ? 'open' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth="2" 
                      d="M12 6v12M6 12h12"
                    />
                  </svg>
                </div>
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;